import { PrmOrganizationEngagementOverviewReportResult } from 'types/schema-generated-types';

export const filterSetsLicensed = (licenseUsage: any[]) =>
  licenseUsage
    ?.filter(lu => lu?.product?.type === 'STUDENT' && lu.assignedCount > 0)
    .map(lu => lu.productCurriculum?.name)
    .join(', ') ?? [];

export const toMinutes = (seconds: number) => Math.round(seconds! / 60);

export const getData = (
  prmOrganizationEngagementOverviewReport: PrmOrganizationEngagementOverviewReportResult
): any[] => {
  const result: any = prmOrganizationEngagementOverviewReport?.organizationOverviews?.map(eor => ({
    school: eor.organization?.name,
    id: eor.organization?.id,
    setsLicensed: filterSetsLicensed(eor.organization?.licenseUsage ?? []),
    totalLicenced: eor.totalStudentCount,
    active: eor.activeStudentCount,
    overallCurriculumProgress: Math.round(eor?.overallProgressPercentage!) + '%',
    averageTime: `${toMinutes(eor?.averageLessonTimeSpentSeconds!)} minutes`
  }));
  return result ?? [];
};
